import { render, staticRenderFns } from "./DefectsEdit.vue?vue&type=template&id=4cb59676&scoped=true&"
import script from "./DefectsEdit.vue?vue&type=script&lang=js&"
export * from "./DefectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb59676",
  null
  
)

export default component.exports